// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */img[data-v-7243e06d],picture[data-v-7243e06d]{position:absolute;top:0;left:0;width:100%;height:100%;-o-object-position:center center;object-position:center center;-o-object-position:var(--object-position,center center);object-position:var(--object-position,center center);-o-object-fit:none;object-fit:none;-o-object-fit:var(--object-fit,none);object-fit:var(--object-fit,none)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
